import { ServerResponse, WhiteLabelProfile } from "@model/commonModel"
import { http } from "./http"

export function getWhiteLabelProfiles(): Promise<
  ServerResponse<WhiteLabelProfile[]>
> {
  return http.get("/white-label/profiles", undefined, { requiresAuth: false })
}
